module.exports = __webpack_public_path__ + "img/ball_9.cf613472.png";